import React, { useState, useEffect } from 'react';
import DesktopLanding from './DesktopLanding';
import MobileLanding from './MobileLanding';
import { LanguageProvider } from '../../../Core/Translations/LanguageContext';

const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.saltd.sudoku";
const APP_STORE_URL = "https://apps.apple.com/us/app/sudoku-vs/id6473940063";

type DeviceType = 'ios' | 'android' | 'desktop';

const detectDevice = (): DeviceType => {
    const userAgent = navigator.userAgent.toLowerCase();

    if (/ipad|iphone|ipod/.test(userAgent) && !(window as any).MSStream) {
        return 'ios';
    }

    if (/android/.test(userAgent)) {
        return 'android';
    }

    if (/mobile|tablet|samsung|samsungbrowser/i.test(userAgent)) {
        return 'android';
    }

    return 'desktop';
};

const Landing: React.FC = () => {
    const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 970);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);

        if (params.has('get-app')) {
            const device = detectDevice();

            if (device !== 'desktop') {
                const storeUrl = device === 'ios' ? APP_STORE_URL : PLAY_STORE_URL;
                window.open(storeUrl, '_blank', 'noopener noreferrer');
            }

            const cleanUrl = window.location.origin + window.location.pathname;
            window.history.replaceState({}, document.title, cleanUrl);
            return;
        }

        const handleResize = () => {
            setIsDesktop(window.innerWidth >= 970);
        };

        // Add event listener
        window.addEventListener('resize', handleResize);

        // Clean up event listener
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <LanguageProvider>
            {isDesktop ? <DesktopLanding /> : <MobileLanding />}
        </LanguageProvider>
    );
};

export default Landing;